module.exports = __webpack_public_path__ + "static/media/ic_checkbox_on.3b4e3c3c.svg";